<template>
    <div id="contenedor-licitaciones-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'LicitacionesMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
